/**
 * TanStack Query hook for `GET /api/main/opps-created` (2026-07-22, John).
 *
 * Main-dashboard twin of useCroOppsCreated: feeds the "Opps Created (trailing 90
 * days)" tile on the /main ACTIVITY section with the SAME payload shape, but from
 * the SF-OAuth `/api/main/*` route so it works on the apex host (where Entra Easy
 * Auth — which /api/cro/* requires — does not exist). Both hooks read the same
 * org-wide `agg_cro_opps_created` cache row server-side.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MetricError } from './useCroScorecard.js';
import type { CroOppsCreatedResponse } from '@saledash/shared';

export function useMainOppsCreated(): UseQueryResult<CroOppsCreatedResponse, MetricError> {
  return useQuery<CroOppsCreatedResponse, MetricError>({
    queryKey: ['main', 'opps-created'],
    queryFn: ({ signal }) =>
      apiFetch<CroOppsCreatedResponse>('/api/main/opps-created', { signal }),
    staleTime: 60_000,
    retry: 2,
  });
}
